import * as z from 'zod';
import { SuretyQuoteStatus, closedReasonSchema, CLOSED_REASON_NOTE_MAX_LENGTH, SuretyType } from '../../../../../enums.mjs';
import { validateCloseRequiredFields } from '../../../../../utils/validate-close-required-fields.util.mjs';
import { Bid } from './bid-contract-surety-quote.dto.mjs';
import { BidToFinal } from './bid-to-final-contract-surety-quote.dto.mjs';
import { UpdateStatus } from './contract-surety-quote.mixins.mjs';
import { Final } from './final-contract-surety-quote.dto.mjs';

var Contract;
(function (Contract) {
    (function (UpdateStatus$1) {
        (function (Request) {
            const approveSchema = z.discriminatedUnion("contractSuretyType", [
                Bid.UpdateStatus.Request.approveSchema,
                Final.UpdateStatus.Request.approveSchema,
                BidToFinal.UpdateStatus.Request.approveSchema,
            ]);
            const declineSchema = UpdateStatus.Request.baseSchema.extend({
                status: z.literal(SuretyQuoteStatus.declined),
            });
            const reviewSchema = UpdateStatus.Request.baseSchema.extend({
                status: z.literal(SuretyQuoteStatus.review),
            });
            const closeSchema = z.object({
                suretyType: z.literal(SuretyType.contract),
                status: z.literal(SuretyQuoteStatus.closed),
                closedReason: closedReasonSchema,
                note: z.string().max(CLOSED_REASON_NOTE_MAX_LENGTH).optional(),
            });
            Request.schema = z
                .discriminatedUnion("status", [approveSchema, declineSchema, reviewSchema, closeSchema])
                .superRefine(validateCloseRequiredFields);
        })(UpdateStatus$1.Request || (UpdateStatus$1.Request = {}));
    })(Contract.UpdateStatus || (Contract.UpdateStatus = {}));
    (function (Update) {
        (function (Request) {
            Request.schema = z.discriminatedUnion("contractSuretyType", [
                Bid.Update.Request.schema,
                Final.Update.Request.schema,
                BidToFinal.Update.Request.schema,
            ]);
        })(Update.Request || (Update.Request = {}));
    })(Contract.Update || (Contract.Update = {}));
    Contract.Bid = Bid;
    Contract.Final = Final;
    Contract.BidToFinal = BidToFinal;
})(Contract || (Contract = {}));

export { Contract };
